module.exports = __webpack_public_path__ + "star-fill-5aac5996d565af0f86a2.svg";